import React from 'react'


export const ConvElem = ({index,classes, children,onClick,el}) => {
  return (

      <div key={index} className={classes.wrapper_element}>
               <div  className={classes.element} data-elid={el.id} onClick={(e) => onClick(e.target, el.hashCode ,index)}>
                  <div className={classes.icon_wrapper}>
                     {
                        el.level?.name ? 
                        <p className={` ${classes.level} ${ classes[el?.level?.name]} `}>{el?.level?.name}</p>
                        :
                        ''
                     }
                    {children}

                     <p className={classes.element_name}>{el.name}</p>
                     
                  </div>
                  <div>
                     
                     <p className={classes.description}>{el.description}</p>
                  </div>
               
               
               </div>
       </div>
   
  )
}
